import React, { Component } from 'react';
import axios from 'axios';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router-dom';
import { sortBy } from 'lodash';
import moment from 'moment';
// material
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Container, Grid, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
// app
import { updateSession, setApiUrls, addAuth, openSnackbar, closeSnackbar } from '../../../store/action-creators';
// containers
import AdminContainer from '../../../containers/Admin';
// models
import { Auth, Session } from '../../../entities/auth';
import { APIUrl } from '../../../entities/site';
import { MessageTemplate, emptyMessageTemplate } from '../../../entities/notification';
// components
import Loading from '../../../components/site/Loading';
import ActionButton from '../../../components/buttons/ActionButton';
import AddTemplate from './components/AddTemplate';

import AuthService from '../../../services/auth';

const useProd = true;

const styles: any = {
  tableWrapper: {
    maxHeight: 800,
    overflow: 'auto',
    marginBottom: 80
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    paddingTop: 10,
    paddingBottom: 10,
    textAlign: 'left'
  }
}

interface AdminTemplatePageProps {
  history: any;
  auth: Auth;
  session: Session;
  apiUrls: APIUrl;
  updateSession(session: Session): void;
  setApiUrls(urls: APIUrl): void;
  openSnackbar(message: string): void;
  closeSnackbar(): void;
}

interface AdminPageState {
  loading: boolean;
  templates: MessageTemplate[];
  openAddTemplate: boolean;
  templateId: string;
}

class AdminTemplatePage extends Component<AdminTemplatePageProps, AdminPageState> {

  constructor(props: AdminTemplatePageProps) {
    super(props);
    this.state = {
      templates: [],
      loading: false,
      openAddTemplate: false,
      templateId: ''
    }
  }

  componentDidMount = async () => {
    this.fetchTemplates();
  }

  fetchTemplates = async () => {
    this.setState({
      loading: true
    });
    const templateRes = await axios.get(`${AuthService.getApiUrls().notifications}/message/templates`);
    console.log('templateRes', templateRes);
    const templates = sortBy(templateRes.data, 'createdDate').reverse();

    this.setState({
      loading: false,
      templates
    });
  }

  handleShowLoading = () => {
    this.setState({ loading: true });
  }

  handleNewTemplate = () => {
    this.setState({ openAddTemplate: true });
  }

  handleEditTemplateCampaign = (templateId: string) => {
    this.setState({
      openAddTemplate: true,
      templateId
    });
  }

  handleDeleteCampaign = async (templateId: string) => {
    try {
      await axios.delete(`${AuthService.getApiUrls().notifications}/message/template/${templateId}`);
      this.props.openSnackbar('Template deleted');
      this.fetchTemplates();
    } catch (error) {
      // error
    }
  }

  handleCloseAddTemplate = () => {
    this.setState({ openAddTemplate: false });
    this.fetchTemplates();
  }

  render() {

    return (
      <AdminContainer showOption={false} private={false} maxWidth={false}>
        <Loading open={this.state.loading} />
        <Container maxWidth="lg">
          <Grid container>
            <Grid xs={10}>
              <div style={styles.title}>Template Admin</div>
            </Grid>
            <Grid xs={2}>
              <ActionButton name="New Template" size="sm" onClick={this.handleNewTemplate} fullWidth />
            </Grid>
          </Grid>
          <Paper>
            <div style={styles.tableWrapper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Client</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Created</TableCell>
                    <TableCell />
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.templates.map((template, index) => (
                    <TableRow key={`address-${index}`}>
                      <TableCell component="th" scope="row">{template.name}</TableCell>
                      <TableCell>{template.description}</TableCell>
                      <TableCell>{template.client}</TableCell>
                      <TableCell>{template.type}</TableCell>
                      <TableCell>{template.category}</TableCell>
                      <TableCell>{moment(template.createdDate).format('MM-DD-YYYY HH:MM')}</TableCell>
                      <TableCell>
                        <IconButton aria-label="edit" onClick={() => this.handleEditTemplateCampaign(template.id)} >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell>
                        <IconButton aria-label="delete" onClick={() => this.handleDeleteCampaign(template.id)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Container>
        <AddTemplate 
          open={this.state.openAddTemplate} 
          templateId={this.state.templateId} 
          onClose={this.handleCloseAddTemplate}
        />
      </AdminContainer>
    )
  }


}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth,
    session: state.session.session,
    apiUrls: state.site.apiUrls
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ updateSession, setApiUrls, addAuth, openSnackbar, closeSnackbar }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(AdminTemplatePage));



// WEBPACK FOOTER //
// ./src/pages/admin/template/AdminTemplates.tsx